export default __webpack_public_path__ + "static/media/bg-all-campaigns.b7c7f184.jpg";